export const currencyTypes = {
  ETH: 0,
  USD: 1,
};
